module.exports = __webpack_public_path__ + "static/media/lekse-k.24e8373d.mp3";